import { defineComponent as _defineComponent } from 'vue'

import { computed, defineComponent, useAsync, useContext, useStore } from "@nuxtjs/composition-api";

import { useVuetify } from "@/composables";
import { LatestPostsImageConfig } from "@/config/images/LatestPosts";
import { getLtksStore } from "@/store/ltks";
import { handleErrorStatusCode, handleServiceError } from "@/utils/api";

const __default__ = defineComponent({
  fetchDelay: 0,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'LatestPosts',
  setup(__props) {

const vuetify = useVuetify();
const store = useStore();
const context = useContext();

const NUMBER_OF_POSTS = 5;

const latestPostIds = computed(() => {
  const ltksStore = getLtksStore(store);
  return ltksStore.ltkFeed("discover").ids?.slice(0, NUMBER_OF_POSTS);
});

const hasLatestPosts = computed(() => latestPostIds.value.length >= NUMBER_OF_POSTS);

const imgSize = computed(
  () =>
    LatestPostsImageConfig[vuetify.breakpoint.name] ?? {
      main: { width: undefined, height: undefined },
      alt: { width: undefined, height: undefined },
    },
);

useAsync(async () => await fetch(), "LatestPosts Fetch");

async function fetch() {
  if (!hasLatestPosts.value) {
    try {
      const ltksStore = getLtksStore(store);
      await ltksStore.fetchLtksByFeatured({ overwrite: false });
    } catch (error) {
      return handleServiceError({
        context,
        error: {
          status: handleErrorStatusCode(error),
          errorCode: "ltk-feed-not-found",
          developerMessage: "Error fetching discover feed",
        },
        originalError: error,
      });
    }
  }
}

return { __sfc: true,vuetify, store, context, NUMBER_OF_POSTS, latestPostIds, hasLatestPosts, imgSize, fetch }
}

})